import React from "react";
import { useIntl } from "react-intl";
import label from "../../i18n/label";
import Message from "../../i18n/Message";
import ModalDialog from "../shared/ModalDialog";
import Spinner from "../../assets/icons/Spinner";

const ConfirmUpgradeDialog = ({ onConfirm, onCancel, planKey, loading = false }) => {
  const intl = useIntl();
  return (
    <ModalDialog onClose={onCancel} closable={!loading}>
      <h1>
        <Message id="change_plan" />
      </h1>
      <div className="upgrade_confirm_text">
        <Message
          id="upgrade_confirm_text"
          values={{ plan: label(intl, "plan_" + planKey) }}
        />
      </div>
      <div className="upgrade_confirm_prorate">
        <Message id="upgrade_confirm_prorate" />
      </div>
      <div className="upgrade_confirm_compare">
        <a href="/p/pricing" target="_blank" rel="noreferrer">
          <Message id="change_plan_compare" />
        </a>
      </div>
      <div className="buttons">
        <button
          className="btn bg-gradient-dark"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? <Spinner /> : <Message id="confirm_upgrade" />}
        </button>
        <button className="btn no-btn" onClick={onCancel} disabled={loading}>
          <Message id="cancel" />
        </button>
      </div>
    </ModalDialog>
  );
};

export default ConfirmUpgradeDialog;
